// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.cms-rich-text[data-v-3c4157ae] {
	width: 100%;
	max-width: 100%;
	text-align: inherit;
	color: inherit;
	line-height: 1.6;
	word-wrap: break-word;
}
.cms-rich-text[data-v-3c4157ae] h2 {
	margin: 0 0 0.5rem 0;
	font-size: 1.5em;
	text-transform: none;
}
.cms-rich-text[data-v-3c4157ae] h3 {
	margin: 0 0 0.5rem 0;
	font-size: 1.25em;
	text-transform: none;
}
.cms-rich-text[data-v-3c4157ae] p {
	margin: 0 0 1rem 0;
}
.cms-rich-text[data-v-3c4157ae] p:last-child {
	margin-bottom: 0;
}
.cms-rich-text[data-v-3c4157ae] ul,
.cms-rich-text[data-v-3c4157ae] ol {
	margin: 0 0 1rem 0;
	padding-left: 1.5rem;
}
.cms-rich-text[data-v-3c4157ae] img {
	max-width: 100%;
	height: auto;
	border-radius: 4px;
	margin: 0.5rem 0;
}
.cms-rich-text[data-v-3c4157ae] a {
	color: var(--site-link-color, #0080FF);
	text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./Application/websites/cms/blocks/richText/richText.vue"],"names":[],"mappings":";AA2CA;CACA,WAAA;CACA,eAAA;CACA,mBAAA;CACA,cAAA;CACA,gBAAA;CACA,qBAAA;AACA;AAEA;CACA,oBAAA;CACA,gBAAA;CACA,oBAAA;AACA;AAEA;CACA,oBAAA;CACA,iBAAA;CACA,oBAAA;AACA;AAEA;CACA,kBAAA;AACA;AAEA;CACA,gBAAA;AACA;AAEA;;CAEA,kBAAA;CACA,oBAAA;AACA;AAEA;CACA,eAAA;CACA,YAAA;CACA,kBAAA;CACA,gBAAA;AACA;AAEA;CACA,sCAAA;CACA,0BAAA;AACA","sourcesContent":["<template>\n\t<div class=\"cms-rich-text\" v-html=\"sanitizedContent\"></div>\n</template>\n\n<script>\n/**\n * RichText.vue\n * ────────────\n * A pure presentational block that renders sanitised HTML content.\n *\n * SECURITY NOTE: The `content` prop is expected to be sanitised at the\n * data layer before it reaches this component (e.g. via DOMPurify on\n * ingest or on the server). As a defence-in-depth measure, the shared\n * sanitizeHtml utility removes <script> and event-handler attributes\n * before rendering.\n *\n * Alignment and typography are wrapper style traits; this block inherits\n * them from the wrapper element.\n *\n * This component knows nothing about the CMS, Vuex, or drag-and-drop.\n * It only accepts standard Vue props.\n */\nimport { sanitizeHtml } from '@/websites/cms/blocks/shared/blockUtils.js';\n\nexport default {\n\tname: 'RichText',\n\n\tprops: {\n\t\tcontent: {\n\t\t\ttype: String,\n\t\t\tdefault: ''\n\t\t}\n\t},\n\n\tcomputed: {\n\t\tsanitizedContent: function () {\n\t\t\treturn sanitizeHtml(this.content);\n\t\t}\n\t}\n};\n</script>\n\n<style scoped>\n.cms-rich-text {\n\twidth: 100%;\n\tmax-width: 100%;\n\ttext-align: inherit;\n\tcolor: inherit;\n\tline-height: 1.6;\n\tword-wrap: break-word;\n}\n\n.cms-rich-text >>> h2 {\n\tmargin: 0 0 0.5rem 0;\n\tfont-size: 1.5em;\n\ttext-transform: none;\n}\n\n.cms-rich-text >>> h3 {\n\tmargin: 0 0 0.5rem 0;\n\tfont-size: 1.25em;\n\ttext-transform: none;\n}\n\n.cms-rich-text >>> p {\n\tmargin: 0 0 1rem 0;\n}\n\n.cms-rich-text >>> p:last-child {\n\tmargin-bottom: 0;\n}\n\n.cms-rich-text >>> ul,\n.cms-rich-text >>> ol {\n\tmargin: 0 0 1rem 0;\n\tpadding-left: 1.5rem;\n}\n\n.cms-rich-text >>> img {\n\tmax-width: 100%;\n\theight: auto;\n\tborder-radius: 4px;\n\tmargin: 0.5rem 0;\n}\n\n.cms-rich-text >>> a {\n\tcolor: var(--site-link-color, #0080FF);\n\ttext-decoration: underline;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
